import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AfterValueChangedDirective } from './after-value-changed.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AfterValueChangedDirective
        
    ],
    exports: [
        AfterValueChangedDirective
    ]

})
export class AfterValueChangeDirectiveModule {
    static forRoot(): ModuleWithProviders<AfterValueChangeDirectiveModule> {
    return {
        ngModule: AfterValueChangeDirectiveModule
    };
}
}
